import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useCloseModalRestriction = () => {
  const { t } = useTranslation('role');
  const { onOpenModal, onResetModal } = useModal();
  const navigate = useNavigate();

  const onCloseRestriction = () => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('cancelModalTitle'),
      contentDescription: t('cancelModalDescription'),
      showPrimaryButton: true,
      primaryButtonText: t('buttonYesCancel'),
      showSecondaryButton: true,
      secondaryButtonText: t('buttonClose'),
      onClickPrimaryButton: () => {
        onResetModal();
        navigate('/master-data/access');
      },
    });
  };

  return onCloseRestriction;
};

export default useCloseModalRestriction;